// extracted by mini-css-extract-plugin
module.exports = {"section19":"Section19_section19__Lx14z"};